import React, {Component} from 'react';
import {Modal, Statistic, Table} from 'antd';
import {Link} from 'react-router';
import moment from 'moment';

const typeFont = ['押金', '工位收入', '地址收入'];

class TableAppoint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payableVisible: false,
      payableTurns: [],
    };
  }

  getSum = data => {
    return data.reduce((prev, current) => {
      return prev + current.price;
    }, 0);
  };

  handleClassName = record => {
    if (!(record.turns && record.turns.length > 0)) {
      return 'no-chiledren';
    }
  };

  PayableTable = () => {
    const columns = [
      {
        title: '转结账单编号',
        dataIndex: 'payableNo',
        key: 'payableNo',
        render: (text, record) => (
          <Link to={`/incubator/bill/${record.payableUuid}/detail`}>{text}</Link>
        ),
      },
      {
        title: '转结金额',
        dataIndex: 'price',
        key: 'price',
      },
    ];

    const data = this.state.payableTurns;
    return data ? <Table columns={columns} dataSource={data} pagination={false} /> : null;
  };

  showPayableTable = record => {
    this.setState({
      payableVisible: true,
      payableTurns: record.turns,
    });
  };

  handleCancel = () => {
    this.setState({
      payableVisible: false,
      payableTurns: [],
    });
  };

  columns = () => {
    return [
      {
        title: '收入类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => <span>{typeFont[text]}</span>,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '付款金额',
        dataIndex: 'initialPrice',
        key: 'initialPrice',
      },
      {
        title: '付款时间',
        dataIndex: 'date',
        key: 'date',
        render: (text, record) => (
          <span>{text ? moment.unix(record.date / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '转结账单',
        dataIndex: 'turns',
        key: 'turns',
        render: (text, record) =>
          record.turns && record.turns.length > 0 ? (
            <Link onClick={() => this.showPayableTable(record)}>查看</Link>
          ) : null,
      },
    ];
  };

  render() {
    const { data } = this.props;
    const { payableVisible } = this.state;
    return (
      <div>
        <Table
          className="nestedTable"
          columns={this.columns()}
          dataSource={data}
          pagination={false}
          rowClassName={this.handleClassName}
          expandedRowKeys={data.map((item, index) => index)}
        />
        <Statistic
          style={{
            display: 'flex',
            lineHeight: '56px',
            justifyContent: 'flex-end',
          }}
          title="总计金额:"
          value={this.getSum(data) ? this.getSum(data).toFixed(2) : ''}
          valueStyle={{ marginLeft: '8px' }}
          suffix="元"
        />
        {payableVisible ? (
          <Modal
            title="转结账单"
            visible={this.state.payableVisible}
            onCancel={this.handleCancel}
            footer={null}
          >
            {this.PayableTable()}
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default TableAppoint;



// WEBPACK FOOTER //
// ./src/components/incubator/settled/TableAppoint.js